import { PlayerSizesTypes } from '../../../../common/store/store.types';

interface PlayPauseButtonStyle {
  playPauseButtonStyle: { [key: string]: any };
  iconAndToolTipContainerStyle: { [key: string]: any };
}

const getPlayPaueButtonStyle = (playerSize, isSplitView, isRecirculationControls, iconWrapperHovered, showGalleryView) => {
  let style = {};
  style = {
    cursor: 'pointer',
    display: 'flex',
    opacity: '0.7',
  };
  switch (playerSize) {
    case 'small':
      style = { ...style, display: 'none' };
      break;
    case 'medium':
      style = { ...style, display: 'none' };
      if (isSplitView || showGalleryView) {
        style = { ...style,
          display: 'flex',
          margin: '0px 4px 0px 8px' };
      }
      break;
    case 'large':
      style = { ...style, margin: '0px 4px 0px 16px' };
      break;
    case 'extraLarge':
      style = { ...style, margin: '0px 4px 0px 24px' };
      break;
    default:
      break;
  }
  if (isRecirculationControls || iconWrapperHovered) {
    style = { ...style, opacity: '1' };
  }
  return style;
};

const iconAndToolTipContainer = {
  position: 'relative',
  display: 'grid',
};

export const getPlayPauseButtonStyleObject = (playerSize: PlayerSizesTypes, iconWrapperHovered: boolean, isSplitView: boolean, showGalleryView: boolean, isRecirculationControls: boolean): PlayPauseButtonStyle => {
  return {
    playPauseButtonStyle: [getPlayPaueButtonStyle(playerSize, isSplitView, isRecirculationControls, iconWrapperHovered, showGalleryView)],
    iconAndToolTipContainerStyle: {
      ...iconAndToolTipContainer,
    },
  };
};
